import styled from 'styled-components'
import { BookMark } from 'svgIcons'
import Skeleton from '@app.components/Skeleton'

const LOADING_ITEM_LENGTH = 20

const LoadingItemList = () => {
  const loadingItems = new Array(LOADING_ITEM_LENGTH).fill('')
  const columnTimes = new Array(4).fill('')
  return (
    <>
      {loadingItems.map((_, index) => {
        return (
          <StyledWrapper key={`loading-item-${index}`}>
            <div className="flex-wrapper">
              {columnTimes.map((_, columnIndex) => {
                return (
                  <div key={columnIndex} className="basic-info">
                    <Skeleton width={100} />
                  </div>
                )
              })}
              <div className="flex-center">
                <div className="content-wrapper">
                  <div className="spec-info">
                    <Skeleton height={16} width={350} />
                  </div>
                  <div className="content">
                    <Skeleton height={70} width={500} />
                  </div>
                </div>
              </div>
            </div>
            <i className="scrap-icon">
              <BookMark className="bookmark-icon" />
            </i>
          </StyledWrapper>
        )
      })}
    </>
  )
}

export default LoadingItemList

const StyledWrapper = styled.div`
  background-color: white;
  padding: 20px 0;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.background.bg_3};
  display: flex;
  align-items: center;
  justify-content: center;

  .flex-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bookmark-icon {
    color: rgba(0, 0, 0, 0.11);
    width: 15px;
  }

  .basic-info {
    width: 100px;
    margin-right: 25px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .spec-info {
    margin-right: 3.75px;
    margin-bottom: 0.5px;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .content {
    margin-right: 3.75px;
    margin-bottom: 0.5px;
    margin-top: 5px;
    width: 100%;
    flex-grow: 1;
  }

  .content-wrapper {
    margin-right: 3.75px;
    flex-grow: 1;
    display: flex;
    min-width: 0;
    max-width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  .scrap-icon {
    padding: 12px 12px 15px;
    flex-shrink: 0;
    margin-left: 20px;
  }

  .flex-center {
    min-width: 0;
    align-items: center;
    display: flex;
  }
`
